import React, { forwardRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import * as Yup from "yup";

import { TextField } from "@mui/material";
import { ButtonsWrapper, StyledForm } from "./styled";

import { getRequiredField } from "helpers/formValidations";
import { ROUTES_CONFIG, ROUTES_PHRASE } from "./config";

import RegularButton from "components/CustomButtons/Button";
import AutocompleteControlled from "components/AutocompleteControlled/AutocompleteControlled";
import { fetchNewRoute, fetchEditRoute } from "redux/actions/buildings/routes/routesActions";

const RoutesSchema = Yup.object({
  [ROUTES_CONFIG.route.key]: Yup.string().required(
    getRequiredField(ROUTES_CONFIG.route.label)
  ),

  [ROUTES_CONFIG.employee.key]: Yup.object().required(
    getRequiredField(ROUTES_CONFIG.employee.label)
  ),
});

export const RouteForm = forwardRef((props) => {
  const dispatch = useDispatch();
  const { handleClose, stationSelected } = props;
  const { isAddMode, deleteMode, employees, editRoute } = useSelector(
    (state) => state.routesBuildings
  );


  const handleCloseForm = () => {
    handleClose();
    reset();
  };

  const {
    reset,
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(RoutesSchema),
  });

  const onSubmit = React.useCallback(
    (formData) => {
      const body = {
        name: formData[ROUTES_CONFIG.route.key],
        idEmployee: formData[ROUTES_CONFIG.employee.key].id,
        idStation: stationSelected.id,
      };

      if (isAddMode) {
        dispatch(fetchNewRoute(body));
      } else {
        dispatch(fetchEditRoute(body, editRoute.id));
      }

      handleCloseForm();
    },
    [reset, isAddMode, editRoute]
  );

  useEffect(() => {
    if (editRoute) {
      const editEmployee = employees.find(
        (employee) => employee.id === editRoute.idEmployee
      );

      setValue(ROUTES_CONFIG.route.key, editRoute[ROUTES_CONFIG.route.key]);

      setValue(ROUTES_CONFIG.employee.key, editEmployee);
    }
  }, [editRoute]);

  useEffect(() => {
    if (isAddMode) {
      reset();
    }
  }, [isAddMode]);

  return (
    <>
      <StyledForm component="form" fullWidth onSubmit={handleSubmit(onSubmit)}>
        <TextField
          fullWidth
          type="text"
          label={ROUTES_CONFIG.route.label}
          variant="outlined"
          error={!!errors[ROUTES_CONFIG.route.key]}
          helperText={errors[ROUTES_CONFIG.route.key]?.message}
          {...register(ROUTES_CONFIG.route.key)}
          size="small"
        />

        <AutocompleteControlled
          name={ROUTES_CONFIG.employee.key}
          label={ROUTES_CONFIG.employee.label}
          options={employees}
          control={control}
        />
        <ButtonsWrapper>
          <RegularButton
            variant="contained"
            color="danger"
            onClick={handleClose}
          >
            {ROUTES_PHRASE.modal.actions.cancel}
          </RegularButton>
          <RegularButton
            variant="contained"
            type="submit"
            color="info"
          >
            {isAddMode
              ? ROUTES_PHRASE.modal.actions.add
              : deleteMode
              ? ROUTES_PHRASE.modal.actions.delete
              : ROUTES_PHRASE.modal.actions.save}
          </RegularButton>
        </ButtonsWrapper>
      </StyledForm>
    </>
  );
});
